export const toggleIds = (id, target, setter) => {
  if (target.checked) setter(n => [...n, id]);
  else setter(n => [...n.filter(x => x != id)]);
};

export default toggleIds;
